module.exports = __webpack_public_path__ + "img/hurling-dark.f5f730c2.svg";